module.exports = require('./helpers/bundle-url').getBundleURL('4ZtNJ') + "empty-folder.c06d9939.svg";